import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";

const store = createPinia();
const app = createApp(App);
document.title = "waizowl driver";
app.use(store).mount("#app");
